import { render, staticRenderFns } from "./ArticleYoutubeVideo.vue?vue&type=template&id=a314a8a6&"
import script from "./ArticleYoutubeVideo.vue?vue&type=script&lang=js&"
export * from "./ArticleYoutubeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
